require('./bootstrap');

import VueSweetalert2 from 'vue-sweetalert2';
import VueToast from 'vue-toast-notification';
import VCalendar from 'v-calendar';
import moment from 'moment';
// Import one of available themes
import 'vue-toast-notification/dist/theme-default.css';
import vSelect from 'vue-select'
import SlideUpDown from 'vue-slide-up-down'
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import Draggable from 'vuedraggable';

import VoerroTagsInput from '@voerro/vue-tagsinput';
import SimpleLightbox from "simplelightbox";



window.moment = moment;
window.Vue = require('vue').default;
window.Vue.use(VueSweetalert2);
window.Vue.use(VueToast);
window.Vue.use(VCalendar);
window.Vue.use(CoolLightBox);
window.Vue.use(Draggable);
window.Vue.component('v-select', vSelect);
window.Vue.component('slide-up-down', SlideUpDown);
window.Vue.component('tags-input', VoerroTagsInput);


window.Vue.directive('tooltip', function(el, binding){
    $(el).tooltip({
        title: binding.value,
        placement: binding.arg,
        trigger: 'hover'
    })
})

/*
Load Vue components
 */
const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

window.token = document.head.querySelector('meta[name="csrf-token"]').content;

window.EventBus = new Vue();
const app = new Vue({
    el: '#app',
});



/*
Dashboard menu
 */
let bars = document.getElementById("menu-bars");
if(bars)
{
    bars.addEventListener('click', function()
    {
        document.getElementById("sidebarWrapper").classList.toggle("active");
        document.getElementById("app").classList.add("active");
    });
}


let overlay = document.getElementById("overlay");
if(overlay)
{
    overlay.addEventListener('click', function()
    {
        document.getElementById("sidebarWrapper").classList.remove("active");
        document.getElementById("app").classList.remove("active");
    });
}
